// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdrInRange,
.rdrStartEdge,
.rdrEndEdge,
.rdrDateDisplay {
  color:rgb(84 140 40) !important;
}
.rdrDayHovered {
  border-color: rgb(84 140 40) !important;
}
.rdrDefinedRangesWrapper {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/core/daterange/custom-styles.css"],"names":[],"mappings":"AAAA;;;;EAIE,+BAA+B;AACjC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;AACf","sourcesContent":[".rdrInRange,\n.rdrStartEdge,\n.rdrEndEdge,\n.rdrDateDisplay {\n  color:rgb(84 140 40) !important;\n}\n.rdrDayHovered {\n  border-color: rgb(84 140 40) !important;\n}\n.rdrDefinedRangesWrapper {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
